var render = function render(){var _vm=this,_c=_vm._self._c;return _c('video',{ref:"video",style:(_vm.styleObject),attrs:{"id":"video","width":_vm.width,"height":_vm.height,"src":_vm.src,"autoplay":_vm.autoplay,"muted":"","playsinline":""},domProps:{"srcObject":_vm.stream,"muted":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }